import { TextureData } from "../../types/types";
import { AppSettings } from "../managers/AppSettings";

export class LoadingStripe extends Phaser.GameObjects.Container {
    public label: Phaser.GameObjects.Text;
    public bg: Phaser.GameObjects.Image;
    public unveilingFg: Phaser.GameObjects.Image;
    public fill: Phaser.GameObjects.TileSprite;

    /**
     * Some texture keys for use in @see LoadingStripe
     * > the reason why these are not frames form atlas is that no atlases are prob preloaded yet.
     * > for that reason, add these to scene 'pack files' to prepack them, before loading starts
     */
    private bgTextureData: TextureData;
    private fillTextureData: TextureData;
    // fill padding from sides of bg
    private fillPadding: number = 10;
    private fillMaskTotalDisplayWidth: number;

    /**
     * Current value of how much content is loaded (this can be manipulated beyond the actual real value)
     */
    private value: number;
    private labelPrefix: string;


    /**
     * Set value for loading stripe completion
     * @param value number from interval <0,1>
     */
    public SetValue(value: number): void {
        this.value = value;

        this.UpdateViewFromPercChange();
    }

    public Init(bgTextureData: TextureData, fillTextureData: TextureData, labelPrefix: string): void {
        this.bgTextureData = bgTextureData;
        this.fillTextureData = fillTextureData;
        this.labelPrefix = labelPrefix;

        this.value = 0;
    }

    public Build(): void {
        // const textureScaleFactor = AppScaleManager.textureScaleFactor;
        const textureScaleFactor = 1;

        // bg
        this.bg = this.scene.add.image(0, 0, this.bgTextureData.texture, this.bgTextureData.frame);
        this.bg.setScale(textureScaleFactor);
        this.bg.setOrigin(0, 0.5)
        this.bg.setPosition(-this.bg.displayWidth * 0.5, 0);
        this.add(this.bg);

        //  If you pass zero as the width and height it'll create a TileSprite
        //  the same size as the frame it uses
        this.fill = this.scene.add.tileSprite(
            0, 0, 0, 0,
            this.fillTextureData.texture,
            this.fillTextureData.frame
        );
        this.fill.setScale(textureScaleFactor);
        this.fill.setOrigin(0, 0.5);
        // this.fill.tileScaleX = 0.5;
        this.fill.setPosition(-this.bg.displayWidth * 0.5 + 10, 0);
        this.add(this.fill);

        // fg that covers fill, and is exposed from left to right (scaleX from 100% to 0%) based on progress
        this.unveilingFg = this.scene.add.image(0, 0, this.bgTextureData.texture, this.bgTextureData.frame);
        this.unveilingFg.setScale(textureScaleFactor);
        this.unveilingFg.setOrigin(1.0, 0.5)
        this.unveilingFg.setPosition(this.bg.displayWidth * 0.5, 0);
        this.add(this.unveilingFg);

        // // fg that covers fill, and is exposed from left to right (scaleX from 100% to 0%) based on progress
        // this.unveilingFg = this.scene.add.image(0, 0, this.bgTextureData.texture, this.bgTextureData.frame);
        // this.unveilingFg.setOrigin(1.0, 0.5)
        // this.unveilingFg.setPosition(this.bg.width/2, 0);
        // this.add(this.unveilingFg);

        // label
        this.label = this.scene.make.text({
            x: 0, y: 20, style: {
                color: '#fff',
                fontSize: "34px",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                shadow: {
                    blur: 8,
                    color: "#000",
                    fill: true,
                },
                metrics: AppSettings.metrics.montserratBold34,
            }
        });
        this.label.setOrigin(0.5, 0);
        this.add(this.label);
        // console.log(this.label.style["metrics"]);
    }

    public UpdateViewFromPercChange(): void {
        // const textureScaleFactor = AppScaleManager.textureScaleFactor;
        const textureScaleFactor = 1;
        this.unveilingFg.scaleX = (1 - this.value) * textureScaleFactor;
        // this.label.setText(this.labelPrefix + " " + (this.perc * 100).toFixed(1) + "%");
        this.label.setText(this.labelPrefix + " " + ((this.value * 100) | 0) + "%");
    }

    public StartAnimate(): void {
        // const textureScaleFactor = AppScaleManager.textureScaleFactor;
        const textureScaleFactor = 1;
        this.scene.tweens.add({
            targets: this.fill,
            tilePositionX: -47 / textureScaleFactor,
            duration: 400,
            repeat: -1
        });
    }

    public StopAnimate(): void {
        this.scene.tweens.killTweensOf(this.fill);
    }

    public override destroy(): void {
        // console.log("LoadingStripe:destroy");

        this.StopAnimate();
        // this.scene.tweens.killAll();

        this.label.destroy();
        this.bg.destroy();
        this.unveilingFg.destroy();
        this.fill.destroy();

        this.bg = null;
        this.unveilingFg = null;;
        this.fill = null;
        this.label = null;

        this.bgTextureData = null;
        this.fillTextureData = null;

        super.destroy();
    }
}